import { createServerFn } from "@tanstack/react-start";
import {
  fetchPublishedPosts,
  fetchPostBySlug,
  fetchRelatedPosts,
} from "@/lib/blog.server";

export const getBlogPosts = createServerFn({ method: "GET" }).handler(async () => ({
  posts: await fetchPublishedPosts(),
}));

export const getBlogPost = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => {
    const post = await fetchPostBySlug(data.slug);
    if (!post) return { post: null, related: [] };
    return { post, related: await fetchRelatedPosts(post.slug, post.category) };
  });
